"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_web_components_1 = require("@nimles/react-web-components");

var react_1 = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var react_redux_2 = require("@nimles/react-redux");

var react_web_components_2 = require("@nimles/react-web-components");

var styled_1 = __importDefault(require("@emotion/styled"));

var TotalAmount = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: 10px;\n  padding-bottom: 10px;\n  font-weight: bold;\n  font-size: 20px;\n"], ["\n  padding-top: 10px;\n  padding-bottom: 10px;\n  font-weight: bold;\n  font-size: 20px;\n"])));

var ShoppingCartItem = function ShoppingCartItem(_a) {
  var cart = _a.cart,
      item = _a.item,
      isEditable = _a.isEditable;
  var dispatch = react_redux_1.useDispatch();

  var _b = react_1.useState(),
      prelQuantity = _b[0],
      setPrelQuantity = _b[1];

  var _c = react_1.useState(item.quantity),
      savedQuantity = _c[0],
      setSavedQuantity = _c[1];

  var _d = react_1.useState(false),
      isUpdating = _d[0],
      setUpdating = _d[1];

  react_1.useEffect(function () {
    (function syncCartItem() {
      return __awaiter(this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!!isUpdating) return [3
              /*break*/
              , 7];
              if (!(prelQuantity !== undefined && prelQuantity != savedQuantity)) return [3
              /*break*/
              , 6];
              _a.label = 1;

            case 1:
              _a.trys.push([1, 3, 4, 5]);

              setUpdating(true);
              return [4
              /*yield*/
              , dispatch(react_redux_2.updateCartItem(cart.id, {
                productId: item.productId,
                quantity: prelQuantity
              }))];

            case 2:
              _a.sent();

              setSavedQuantity(prelQuantity);
              return [3
              /*break*/
              , 5];

            case 3:
              e_1 = _a.sent();
              setPrelQuantity(undefined);
              return [3
              /*break*/
              , 5];

            case 4:
              setUpdating(false);
              return [7
              /*endfinally*/
              ];

            case 5:
              return [3
              /*break*/
              , 7];

            case 6:
              setPrelQuantity(undefined);
              setSavedQuantity(undefined);
              _a.label = 7;

            case 7:
              return [2
              /*return*/
              ];
          }
        });
      });
    })();
  }, [prelQuantity, isUpdating]);

  var changeCartItemQuantity = function changeCartItemQuantity(item, e) {
    return __awaiter(void 0, void 0, void 0, function () {
      var value;
      return __generator(this, function (_a) {
        e.preventDefault();
        value = Number(e.target.value);
        setPrelQuantity(value);
        return [2
        /*return*/
        ];
      });
    });
  };

  return react_1.default.createElement(react_web_components_1.ListItem, null, react_1.default.createElement(react_web_components_1.Row, {
    wrap: true,
    align: "center"
  }, react_1.default.createElement(react_web_components_1.Column, {
    flex: true
  }, item.product && item.product.name), react_1.default.createElement(react_web_components_1.Column, {
    xs: 60,
    md: 15,
    align: "flex-end"
  }, react_1.default.createElement(react_web_components_2.Price, null, item.product && item.product.netPrice)), react_1.default.createElement(react_web_components_1.Column, {
    width: "120px"
  }, isEditable ? react_1.default.createElement(react_web_components_1.Input, {
    align: "right",
    type: "number",
    value: prelQuantity || item.quantity,
    onChange: function onChange(e) {
      return changeCartItemQuantity(item, e);
    }
  }) : item.quantity), react_1.default.createElement(react_web_components_1.Column, {
    xs: 20,
    md: 15,
    align: "flex-end"
  }, react_1.default.createElement(react_web_components_2.Price, null, item.product && item.product.netPrice * item.quantity))));
};

exports.ShoppingCart = function (_a) {
  var cart = _a.cart,
      isEditable = _a.isEditable;
  var cartItems = cart && cart.items && cart.items.map(function (item) {
    return __assign({}, item);
  });
  var totalAmount = cartItems && cartItems.reduce(function (sum, item) {
    return sum + item.product.netPrice * item.quantity;
  }, 0);
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(react_web_components_1.List, null, cartItems && cartItems.map(function (item, index) {
    return react_1.default.createElement(ShoppingCartItem, {
      key: index,
      cart: cart,
      item: item,
      isEditable: isEditable
    });
  })), react_1.default.createElement(react_web_components_2.Divider, null), react_1.default.createElement(react_web_components_1.Row, {
    justify: "flex-end"
  }, react_1.default.createElement(react_web_components_1.Column, {
    padding: true
  }, react_1.default.createElement(TotalAmount, null, react_1.default.createElement(react_web_components_2.Price, null, totalAmount)))));
};

var templateObject_1;